import Layout from "@xtribe/shared/components/lib/Layout/Layout";
import SignUpForm from "@xtribe/shared/components/Auth/SignUpForm";
import NextHead from "@xtribe/shared/components/lib/Head/NextHead";
import { GetServerSideProps } from "next";
import { getRequestSlug } from "@xtribe/shared/lib/host";
import { getPublicTeamData } from "./api/v0/teams/public";
import { Team, TeamMembershipSettings } from "@prisma/client";
import { serializeQuery } from "@xtribe/shared/lib/text-transformations";

export interface AuthPageProps {
  team: Team & {
    settings?: { id: string; memberships?: TeamMembershipSettings };
  };
  queryString: string;
  query: { [key: string]: string };
}

const SignUp: React.FC<AuthPageProps> = ({ team, queryString }) => {
  let content;
  content = <SignUpForm team={team} queryString={queryString} />;
  return (
    <div className="theme-admin">
      <NextHead
        title={`Jetzt Registrieren — ${team?.name ?? "xTribe"}`}
        description={`Registriere dich jetzt bei ${team?.name ?? "xTribe"} an.`}
      />
      <Layout>
        <div
          className={`px-2 md:px-4 min-h-screen flex
            items-center py-8 md:py-32`}
        >
          {content}
        </div>
      </Layout>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  let requestHost;
  const host = ctx.req.headers.host;
  if (
    process.env.NEXT_PUBLIC_APP_URL!?.includes(host ?? "") ||
    process.env.NEXT_PUBLIC_AUTH_URL!?.includes(host ?? "")
  ) {
    requestHost = ctx.query.request_host;
  } else {
    requestHost = host;
  }
  let slug;
  let customDomain;
  if (
    requestHost?.includes(process.env.NEXT_PUBLIC_APP_HOST!) ||
    requestHost?.includes("ghoststudio.io")
  ) {
    slug = getRequestSlug(requestHost.toString());
  } else {
    customDomain = requestHost?.toString();
  }
  let team = null;
  if (slug || customDomain) {
    team = await getPublicTeamData({ slug, customDomain, isSignup: true });
  }
  const queryString = serializeQuery(ctx.query);
  return { props: { team, queryString, query: ctx.query } };
};
export default SignUp;
